// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import WhereController from "./where_controller"
application.register("where", WhereController)

import PaymentController from "./payment_controller"
application.register("payment", PaymentController)

import RefundController from "./refund_controller"
application.register("refund", RefundController)

import SpeakerController from "./speaker_controller"
application.register("speaker", SpeakerController)

import FundController from "./fund_controller"
application.register("fund", FundController)

import { DmTest, TurboModalController } from "dm_unibo_common"
application.register("turbo-modal", TurboModalController)

